var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { ControlPanelSelectors } from './controlPanelSelectors';
import { ControlPanelSetting } from './controlPanelSetting';
export var ControlPanel = function (_a) {
    var filtersProps = _a.filtersProps;
    return (_jsxs(Stack, __assign({ direction: "row", alignItems: "end", justifyContent: "space-between", gap: 4, flexWrap: "wrap" }, { children: [_jsx(ControlPanelSetting, __assign({}, filtersProps.settingProps)), _jsx(ControlPanelSelectors, __assign({}, filtersProps.selectorsProps))] })));
};
